import axios from "axios";
// import { browserName, osName, isMobile } from "react-device-detect";

// const BaseURL = "https://rdo-api.polalubindo.co.id";
// const BaseURL = "http://localhost:4000";
// const BaseURL = "https://apicoba-rdo.daffaakbar.com";
const BaseURL = "https://api.rematha.co.id";
// const BaseURL = "https://morning-sea-94094.herokuapp.com/";
// const BaseURL = 'https://apibasicweb.betonperkasa.com';

const API = axios.create({
  baseURL: BaseURL,
});

export { API, BaseURL };
